export const RESET_REFERRER = 'RESET_REFERRER'

export interface ResetReferrerAction {
  type: typeof RESET_REFERRER
}

export const resetReferrerAction = () => ({
  type: RESET_REFERRER,
})
